// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-dialog.chat-list label {
    font-weight: 500;
}
.chat-list .group-member input {
    cursor: pointer;
}
.group-member ul li {
    padding: 5px 15px;
    list-style: none;
    background: #ddd;
    border-radius: 18px;
    font-size: 16px; 
}
.group-member ul li span {
    font-size: 16px;
    margin: 0 5px;
    cursor: pointer;
}
.chat-msg {
    height: 75vh;
    padding-left: 8px !important;
}
.message-box {
    height: 60vh;
    overflow-y: scroll;
}
.user-text-box {
    background: #f1f1f1;
}
.user-text {
    background: #f1f1f1;
    border-radius: 10px;
}
.user-share {
    background: #fff;
    border-radius: 10px;
}
.user-share a {
    color: #212529;
}
.user-text i {
    cursor: pointer;
}
/* .user-text span {
    background: #f1f1f1;
    border-radius: 5px;
} */
.chat-box {
    background: #fafafa;
}
.chat-user.active {
    background: #445773;
}
.chat-user {
    cursor: pointer;
}
.chat-user-list {
    background: #2F3C4E;
    color: #fff;
    position: relative;
    padding: 0;
    height: 75vh;
    overflow-y: scroll;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.chat-user-list ::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.chat-user-list {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.chat-user-list h3 {
    padding: 5px 0;
    border-bottom: 1px solid #fff;
}
.chat-options .defult-button-head {
    width: unset;
    padding: 5px 20px;
}
.chat-options .table-viewcustom-button, .chat-options .table-custom-button {
    padding: 5px 10px;
}
.chat-box {
    display: block;
}
.chat-box.chart-start-msg {
    font-size: 3.5vw;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ddd;
    text-shadow: 1px 1px #b32523;
}
.chatborder img{
    border: 1px solid;
    padding: 2px;
    border-radius: 20px
}
.placeholder-icon {
    border: 1px solid;
    padding: 6px;
    border-radius: 20px
}
@media (max-width: 600px) {
    .chat-user .border{
        display: none;
    }
    .chat-user .single-chat-user {
        padding: 5px;
        margin: 5px 0;
        font-size: 13px;
    }
    .chat-msg {
        height: 85vh;
    }
}

.label-cus {
    background-color: indigo;
    color: white;
    padding: 0.5rem;
    font-family: sans-serif;
    border-radius: 0.3rem;
    cursor: pointer;
    margin-top: 1rem;
}

.cut-text { 
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100px;
    height: 1.2em;
    white-space: nowrap;
    display: inline-block;
}

.cus-logo-grp img, .cus-logo-grp i {
    width: 30px ;
    height: auto;
    border-radius: 100%;
}
.cus-msg-menu ul {
    display: none;
    right: 0;
    background: white;
    z-index: 1;
    padding: 1rem 0;
    list-style: none;
    text-align: left;
    border: 1px solid transparent;
    box-shadow: 0 2px 5px 1px rgba(64,60,67,.16);
    border-radius: 5px;
}

.cus-msg-menu  ul li {
    padding: 0.5rem 1rem;
}

.cus-msg-menu  ul li:hover {
    cursor: pointer;
    background-color: #f5f5f5;
}
.cus-msg-menu .cus-options:hover ul {
    display: block !important;
}

.cus-msg-image {
    height: auto;
    width: 200px;
}`, "",{"version":3,"sources":["webpack://./src/pages/layouts/chat/chat.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;AACA;IACI,YAAY;IACZ,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;;;GAGG;AACH;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;AACtB;AACA,gDAAgD;AAChD;IACI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;EACE,wBAAwB,GAAG,gBAAgB;EAC3C,qBAAqB,GAAG,YAAY;AACtC;AACA;IACI,cAAc;IACd,6BAA6B;AACjC;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ;AACJ;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,aAAa;QACb,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,QAAQ;IACR,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".modal-dialog.chat-list label {\r\n    font-weight: 500;\r\n}\r\n.chat-list .group-member input {\r\n    cursor: pointer;\r\n}\r\n.group-member ul li {\r\n    padding: 5px 15px;\r\n    list-style: none;\r\n    background: #ddd;\r\n    border-radius: 18px;\r\n    font-size: 16px; \r\n}\r\n.group-member ul li span {\r\n    font-size: 16px;\r\n    margin: 0 5px;\r\n    cursor: pointer;\r\n}\r\n.chat-msg {\r\n    height: 75vh;\r\n    padding-left: 8px !important;\r\n}\r\n.message-box {\r\n    height: 60vh;\r\n    overflow-y: scroll;\r\n}\r\n.user-text-box {\r\n    background: #f1f1f1;\r\n}\r\n.user-text {\r\n    background: #f1f1f1;\r\n    border-radius: 10px;\r\n}\r\n.user-share {\r\n    background: #fff;\r\n    border-radius: 10px;\r\n}\r\n.user-share a {\r\n    color: #212529;\r\n}\r\n.user-text i {\r\n    cursor: pointer;\r\n}\r\n/* .user-text span {\r\n    background: #f1f1f1;\r\n    border-radius: 5px;\r\n} */\r\n.chat-box {\r\n    background: #fafafa;\r\n}\r\n.chat-user.active {\r\n    background: #445773;\r\n}\r\n.chat-user {\r\n    cursor: pointer;\r\n}\r\n.chat-user-list {\r\n    background: #2F3C4E;\r\n    color: #fff;\r\n    position: relative;\r\n    padding: 0;\r\n    height: 75vh;\r\n    overflow-y: scroll;\r\n}\r\n/* Hide scrollbar for Chrome, Safari and Opera */\r\n.chat-user-list ::-webkit-scrollbar {\r\n    display: none;\r\n}\r\n\r\n/* Hide scrollbar for IE, Edge and Firefox */\r\n.chat-user-list {\r\n  -ms-overflow-style: none;  /* IE and Edge */\r\n  scrollbar-width: none;  /* Firefox */\r\n}\r\n.chat-user-list h3 {\r\n    padding: 5px 0;\r\n    border-bottom: 1px solid #fff;\r\n}\r\n.chat-options .defult-button-head {\r\n    width: unset;\r\n    padding: 5px 20px;\r\n}\r\n.chat-options .table-viewcustom-button, .chat-options .table-custom-button {\r\n    padding: 5px 10px;\r\n}\r\n.chat-box {\r\n    display: block;\r\n}\r\n.chat-box.chart-start-msg {\r\n    font-size: 3.5vw;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: #ddd;\r\n    text-shadow: 1px 1px #b32523;\r\n}\r\n.chatborder img{\r\n    border: 1px solid;\r\n    padding: 2px;\r\n    border-radius: 20px\r\n}\r\n.placeholder-icon {\r\n    border: 1px solid;\r\n    padding: 6px;\r\n    border-radius: 20px\r\n}\r\n@media (max-width: 600px) {\r\n    .chat-user .border{\r\n        display: none;\r\n    }\r\n    .chat-user .single-chat-user {\r\n        padding: 5px;\r\n        margin: 5px 0;\r\n        font-size: 13px;\r\n    }\r\n    .chat-msg {\r\n        height: 85vh;\r\n    }\r\n}\r\n\r\n.label-cus {\r\n    background-color: indigo;\r\n    color: white;\r\n    padding: 0.5rem;\r\n    font-family: sans-serif;\r\n    border-radius: 0.3rem;\r\n    cursor: pointer;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.cut-text { \r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    width: 100px;\r\n    height: 1.2em;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n}\r\n\r\n.cus-logo-grp img, .cus-logo-grp i {\r\n    width: 30px ;\r\n    height: auto;\r\n    border-radius: 100%;\r\n}\r\n.cus-msg-menu ul {\r\n    display: none;\r\n    right: 0;\r\n    background: white;\r\n    z-index: 1;\r\n    padding: 1rem 0;\r\n    list-style: none;\r\n    text-align: left;\r\n    border: 1px solid transparent;\r\n    box-shadow: 0 2px 5px 1px rgba(64,60,67,.16);\r\n    border-radius: 5px;\r\n}\r\n\r\n.cus-msg-menu  ul li {\r\n    padding: 0.5rem 1rem;\r\n}\r\n\r\n.cus-msg-menu  ul li:hover {\r\n    cursor: pointer;\r\n    background-color: #f5f5f5;\r\n}\r\n.cus-msg-menu .cus-options:hover ul {\r\n    display: block !important;\r\n}\r\n\r\n.cus-msg-image {\r\n    height: auto;\r\n    width: 200px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
